var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"pair-list-container"},_vm._l((_vm.computedItems),function(item){return _c('li',{key:item.type + item.value,staticClass:"pair list-item"},[_c('h4',{staticClass:"type text-caps"},[_vm._v(_vm._s(item.type))]),_c('h3',{staticClass:"value text-description"},[_vm._v(_vm._s(item.value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }